import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Hero: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="relative overflow-hidden bg-primary">
      <div className="container mx-auto px-6 pt-40 pb-10 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        {/* Text column */}
        <div className="flex flex-col items-center text-center order-1">
          <motion.h1
            initial={{ y: 20, opacity: 0 }}
            animate={isLoaded ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-normal leading-[1.05] uppercase break-words"
            style={{ fontFamily: "'Poppins', sans-serif", color: '#5E495C' }}
          >
            You are not broken.<br />
            The plan was never built for{' '}
            <span className="text-secondary underline decoration-4 underline-offset-4">your life.</span>
          </motion.h1>

          {/* Pain point copy */}
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={isLoaded ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.7 }}
            className="mt-5 max-w-lg mx-auto text-sm sm:text-lg md:text-xl text-dark/80 leading-relaxed"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Send me your diet 100% anonymously. I'll show you why it's not working and what would!
          </motion.p>

          {/* CTA button */}
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={isLoaded ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 1.0 }}
            className="mt-8"
          >
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSe5GqmFAJ-6kgbrJLgMRuIQoYdu-hguwIgSoPJ9-QsUonFhXA/viewform?usp=dialog"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative inline-flex items-center justify-center px-8 py-3.5 text-sm sm:text-base md:text-lg rounded-full font-bold tracking-wide uppercase transition-all duration-300 shadow-[0_0_25px_rgba(199,106,162,0.4)] hover:shadow-[0_0_40px_rgba(199,106,162,0.6)] hover:scale-105 overflow-hidden"
              style={{
                background: 'linear-gradient(135deg, #c76aa2 0%, #9f5582 100%)',
                color: '#fff',
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              <span className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700" />
              <span className="relative">Send Me Your Diet</span>
            </a>
          </motion.div>

        </div>

        {/* Photo column */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={isLoaded ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="order-2 flex flex-col items-center lg:items-end"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/karina-hero-photo.webp`}
            alt="Karina Padden in her kitchen"
            width={848}
            height={1000}
            fetchPriority="high"
            loading="eager"
            decoding="async"
            className="w-full max-w-[280px] sm:max-w-[360px] lg:max-w-none lg:w-auto lg:h-[475px] rounded-2xl object-contain"
          />

          {/* Secondary route - not a competing CTA */}
          <motion.a
            href="https://youtube.com/@the_proteinprincess?si=Aou3ATj7lodKbMs3"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0 }}
            animate={isLoaded ? { opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 1.3 }}
            className="mt-3 inline-block text-center text-dark text-xs sm:text-sm hover:text-secondary transition-colors duration-200"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            {'Watch it here \u00a0\u2192\u00a0'}
            <span className="underline underline-offset-4 decoration-dark hover:decoration-secondary">
              She Sent Me Her Diet
            </span>
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
